<div *ngIf="tableTheme !== 'sub-table'" class="filter-row">
    <div class="search-bar" *ngIf="FILTER_SUBJECT == null && !hideSearchBar">
        <input
            class="search-input"
            matInput
            (keyup)="applyFilter($event.target.value)"
            placeholder="{{ 'aumico_core_table_filter_placeholder' | i18next }}"
        />
    </div>
</div>
<div class="{{ tableTheme }}">
    <mat-table [dataSource]="datasource">
        <ng-container *ngFor="let column of getColumns()" [matColumnDef]="column.name">
            <!-- Checkbox Column -->
            <div *ngIf="column.name === 'select'">
                <mat-header-cell *matHeaderCellDef aum-checkbox-cell>
                    <mat-checkbox
                        *ngIf="!singleSelection"
                        (change)="$event ? masterToggle() : null"
                        [checked]="checkboxSelection.hasValue() && isAllCheckboxesSelected()"
                        [indeterminate]="checkboxSelection.hasValue() && !isAllCheckboxesSelected()"
                    >
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" aum-checkbox-cell>
                    <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="$event ? handleSelection($event, row) : null"
                        [checked]="
                            singleSelectionProperty != null && row[singleSelectionProperty] === savedSingleSelectionId
                                ? true
                                : checkboxSelection.isSelected(row)
                        "
                        [disabled]="row.disableSelection"
                    >
                    </mat-checkbox>
                </mat-cell>
            </div>
            <!-- Favourite Column-->
            <div *ngIf="column.name === 'favorite'">
                <mat-header-cell mat-header-cell *matHeaderCellDef aum-favorite-cell></mat-header-cell>
                <mat-cell mat-cell *matCellDef="let row" aum-favorite-cell>
                    <input class="star" type="checkbox" />
                    <!-- <mat-checkbox class ="star" (click)="$event.stopPropagation()"
                            (change)="$event ? favoriteSelection.toggle(row) : null"
                            [checked]="favoriteSelection.isSelected(row)">
                    </mat-checkbox> -->
                </mat-cell>
            </div>
            <!-- Settings Column -->
            <div *ngIf="column.name === 'settings'">
                <mat-header-cell
                    [style.flex]="column?.flex ? column?.flex : null"
                    mat-header-cell
                    *matHeaderCellDef
                    aum-settings-cell
                >
                    <aum-menu
                        (click)="onMenuClick()"
                        [items]="OPTIONS.menu ? OPTIONS.menu.items : []"
                        [delegate]="this"
                    ></aum-menu>
                </mat-header-cell>
                <mat-cell
                    mat-cell
                    *matCellDef="let element"
                    aum-settings-cell
                    [style.flex]="column?.flex ? column?.flex : null"
                >
                    <ng-container *ngIf="OPTIONS.menu?.actionButtons">
                        <ng-container *ngFor="let actionButton of OPTIONS.menu?.actionButtons">
                            <div
                                class="action-button"
                                (click)="onMenuItemPerRowClick(actionButton.action, element)"
                                stopPropagation
                            >
                                <mat-icon class="action-icon" [svgIcon]="actionButton.icon"> </mat-icon>
                                <span class="aum-typo-paragraph-s">{{ actionButton.caption }}</span>
                            </div>
                        </ng-container>
                    </ng-container>
                </mat-cell>
            </div>
            <div *ngIf="column.name === 'actions'">
                <mat-header-cell class="aum-typo-table-header" *matHeaderCellDef>
                    {{ column.name }}
                </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element">
                    <aum-menu-item-per-row
                        *ngIf="!element.disableActions"
                        [items]="OPTIONS.menuPerRow ? OPTIONS.menuPerRow.items : []"
                        [delegate]="this"
                        [row]="element"
                        (click)="$event.stopPropagation()"
                    >
                    </aum-menu-item-per-row>
                </mat-cell>
            </div>
            <div
                *ngIf="
                    column.name !== 'select' &&
                    column.name !== 'settings' &&
                    column.name !== 'favorite' &&
                    column.name !== 'actions'
                "
            >
                <mat-header-cell
                    mat-header-cell
                    *matHeaderCellDef
                    class="aum-typo-table-header"
                    [style.flex]="column?.flex ? column?.flex : null"
                >
                    <span *ngIf="!column?.hideColumnName"> {{ column.name }}</span>
                </mat-header-cell>
                <mat-cell
                    mat-cell
                    *matCellDef="let element"
                    [style.flex]="column?.flex ? column?.flex : null"
                    [id]="column.name"
                >
                    <ng-container [ngSwitch]="column?.type">
                        <div *ngSwitchCase="'button'">
                            <aumico-button
                                *ngIf="element?._id"
                                class="aum-typo-paragraph-s"
                                (click)="onRowButtonClicked(element[column?.property], column?.action)"
                                >{{ column.name }}
                            </aumico-button>
                        </div>

                        <div *ngSwitchCase="'date'" class="aum-typo-paragraph-s">
                            {{ (element[column?.property] | dateLocale) || '-' }}
                        </div>
                        <div *ngSwitchCase="'truncated-text'" class="aum-typo-paragraph-s">
                            {{ (element[column?.property] | slice : 0 : 20) || '-' }}
                        </div>
                        <div *ngSwitchCase="'translated-text'" class="aum-typo-paragraph-s">
                            {{ (element[column?.property] | valueFor) || '-' }}
                        </div>
                        <div *ngSwitchCase="'status'" class="aum-typo-paragraph-s">
                            <span class="{{ determineStatusClass(element[column?.property]) }}"></span>&nbsp;&nbsp;{{
                                element[column?.property] || '-'
                            }}
                        </div>
                        <div *ngSwitchCase="'progress'" class="aum-typo-paragraph-s">
                            {{ element[column?.property] || '-' }}
                            <br />
                            <mat-progress-bar mode="determinate" value="40"></mat-progress-bar>
                        </div>
                        <div *ngSwitchCase="'text-with-ellipsis'" class="aum-typo-paragraph-s text-overflow-ellipsis">
                            {{ element[column?.property] || '-' }}
                        </div>
                        <div *ngSwitchCase="'img'" class="profile-img">
                            <div *ngIf="element[column?.property] == null" class="img-placeholder"></div>
                            <img
                                *ngIf="element[column?.property] != null"
                                class="img-width-height"
                                [src]="element[column?.property]"
                                alt="Photo-Url"
                            />
                        </div>
                        <div *ngSwitchCase="'array'" class="aum-typo-paragraph-s">
                            {{ element[column?.property] | joinArray : ', ' || '-' }}
                        </div>
                        <div *ngSwitchCase="'active'">
                            <mat-radio-group>
                                <mat-radio-button
                                    *ngIf="element[column?.property] === 'false'"
                                    checked
                                    [disabled]="true"
                                    >{{ 'aumico_admin_user_list_status_inactive' | i18next }}</mat-radio-button
                                >
                                <mat-radio-button class="active" *ngIf="element[column?.property] === 'true'" checked>{{
                                    'aumico_admin_user_list_status_active' | i18next
                                }}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div *ngSwitchDefault class="aum-typo-paragraph-s">
                            {{ element[column?.property] || '-' }}
                        </div>
                    </ng-container>
                </mat-cell>
            </div>
        </ng-container>

        <mat-header-row *matHeaderRowDef="headers"></mat-header-row>
        <mat-row
            *matRowDef="let row; columns: headers; let index = index"
            matRipple
            class="element-row"
            [ngClass]="OPTIONS.rowClickAction ? 'clickable' : ''"
            (click)="rowClicked(index, row)"
            [ngClass]="{ 'highlight-row': highlightRows && selectedRow === row }"
            #expandableRow
        ></mat-row>
    </mat-table>
</div>

<div *ngIf="tableTheme !== 'sub-table'">
    <aum-pagination-action-bar
        #paginator
        #aumpaginator
        [pageSizeOptions]="[20, 50, 100]"
        showFirstLastButtons
        [userPreferredNumberOfDocumentsPerPage]="userPreferredNumberOfDocumentsPerPage"
        (page)="onPageSelectionChange($event)"
    ></aum-pagination-action-bar>
</div>
